import { gql } from '@apollo/client';

export const TextBlockFragment = gql`
  fragment TextBlockFragment on TextBlock {
    ... on TextBlock {
      __typename
      backgroundColor
      bulletType
      columnType
      content
      ctas {
        id
        text
        url
      }
      icon {
        file {
          url
        }
      }
      customBackgroundColor
      id
      textAlignment
      title
    }
  }
`;

export default {};
